import React, { createContext, useContext, useEffect, useState } from 'react';
import { supabase } from '../supabaseClient';
import { puzzles as mockPuzzles } from '../data/mockData';

const PuzzleContext = createContext();

export const usePuzzles = () => {
  return useContext(PuzzleContext);
};

export const PuzzleProvider = ({ children }) => {
  const [puzzles, setPuzzles] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  useEffect(() => {
    const fetchPuzzles = async () => {
      try {
        const { data: puzzlesData, error: puzzlesError } = await supabase
          .from('puzzles')
          .select(`
            date,
            title,
            clues (
              id,
              number,
              direction,
              text,
              answer,
              hint_1,
              hint_2,
              hint_3,
              slug
            )
          `)
          .order('date', { ascending: false });

        if (puzzlesError) throw puzzlesError;

        if (puzzlesData && puzzlesData.length > 0) {
          // Transform data to match existing app structure
          const formattedPuzzles = puzzlesData.map(puzzle => {
            const across = puzzle.clues
              .filter(c => c.direction === 'across')
              .sort((a, b) => a.number - b.number);
            
            const down = puzzle.clues
              .filter(c => c.direction === 'down')
              .sort((a, b) => a.number - b.number);

            return {
              date: puzzle.date,
              title: puzzle.title,
              puzzleNumber: puzzle.title.match(/#(\d+)/) ? puzzle.title.match(/#(\d+)/)[1] : null,
              clues: {
                across,
                down
              }
            };
          });
          setPuzzles(formattedPuzzles);
        } else {
            // Fallback to mock data if DB is empty so the site doesn't look broken
            // while user is setting it up
            console.log('No data in Supabase, using mock data');
            const mockWithNumbers = mockPuzzles.map(p => ({
              ...p,
              puzzleNumber: p.title.match(/#(-?\d+)/) ? p.title.match(/#(-?\d+)/)[1] : null
            }));
            setPuzzles(mockWithNumbers);
        }
      } catch (err) {
        console.error('Error fetching puzzles:', err);
        setError(err.message);
        // Fallback to mock data on error for now
        const mockWithNumbers = mockPuzzles.map(p => ({
          ...p,
          puzzleNumber: p.title.match(/#(-?\d+)/) ? p.title.match(/#(-?\d+)/)[1] : null
        }));
        setPuzzles(mockWithNumbers);
      } finally {
        setLoading(false);
      }
    };

    fetchPuzzles();
  }, []);

  const value = {
    puzzles,
    loading,
    error
  };

  return (
    <PuzzleContext.Provider value={value}>
      {children}
    </PuzzleContext.Provider>
  );
};

